var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.725C0 1.12557 0.324429 1.45 0.725 1.45V12.325C0.324429 12.325 0 12.6494 0 13.05C0 13.4506 0.324429 13.775 0.725 13.775H21.025C21.4256 13.775 21.75 13.4506 21.75 13.05C21.75 12.6494 21.4256 12.325 21.025 12.325V1.45C21.4256 1.45 21.75 1.12557 21.75 0.725C21.75 0.324429 21.4256 0 21.025 0H0.725C0.324429 0 0 0.324429 0 0.725ZM5.43762 3.26262C5.83819 3.26262 6.16262 3.58704 6.16262 3.98762V9.78762C6.16262 10.1882 5.83819 10.5126 5.43762 10.5126C5.03704 10.5126 4.71262 10.1882 4.71262 9.78762V3.98762C4.71262 3.58704 5.03704 3.26262 5.43762 3.26262ZM9.78762 3.98762C9.78762 3.58704 9.46319 3.26262 9.06262 3.26262C8.66204 3.26262 8.33762 3.58704 8.33762 3.98762V9.78762C8.33762 10.1882 8.66204 10.5126 9.06262 10.5126C9.46319 10.5126 9.78762 10.1882 9.78762 9.78762V3.98762ZM12.6876 3.26262C13.0882 3.26262 13.4126 3.58704 13.4126 3.98762V9.78762C13.4126 10.1882 13.0882 10.5126 12.6876 10.5126C12.287 10.5126 11.9626 10.1882 11.9626 9.78762V3.98762C11.9626 3.58704 12.287 3.26262 12.6876 3.26262ZM17.0376 3.98762C17.0376 3.58704 16.7132 3.26262 16.3126 3.26262C15.912 3.26262 15.5876 3.58704 15.5876 3.98762V9.78762C15.5876 10.1882 15.912 10.5126 16.3126 10.5126C16.7132 10.5126 17.0376 10.1882 17.0376 9.78762V3.98762Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerIcon);
export default __webpack_public_path__ + "static/media/container-icon.537d8d060767ef4fc30451e4fb1cf185.svg";
export { ForwardRef as ReactComponent };